import React, { useState, useEffect } from 'react'
import { Icon } from '../Icon/Icon'
import Button from '../Button/Button'
import PrimaryText from '../Text/PrimaryText'
import VerticalGroup from '../VerticalGroup/VerticalGroup'

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false)

  const toggleVisibility = () => {
    if (window.pageYOffset > 600) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility)
    return () => window.removeEventListener('scroll', toggleVisibility)
  }, [])

  return isVisible ? (
    <VerticalGroup className="fixed bottom-5 right-5 opacity-75" center>
      <Button
        className="border-gray border"
        size="xs"
        onClick={scrollToTop}
        rounded="full"
      >
        <Icon size={7} colour="white" type={'chevronUp'}></Icon>
      </Button>
      <PrimaryText weight="bold" colour="primary"></PrimaryText>
    </VerticalGroup>
  ) : null
}

export default ScrollToTop
